const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

export default allowedExtensions;
